import api from './api';

export const getAllUsers = async (auth) => {
  const response = await api.get('/users', {
    headers: { Authorization: `Bearer ${auth.token}` },
  });
  return response.data;
};

export const deleteUser = async (id, auth) => {
  const response = await api.delete(`/users/${id}`, {
    headers: { Authorization: `Bearer ${auth.token}` },
  });
  return response.data;
};

export const createUser = async (userData, auth) => {
  const response = await api.post('/users', userData, {
    headers: { Authorization: `Bearer ${auth.token}` },
  });
  return response.data;
};
